var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('vue-progress-bar'),_vm._v(" "),_c('core-header'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('core-sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('core-breadcrumb'),_vm._v(" "),_c('div',{staticClass:"container-fluid alpha omega"},[_c('router-view')],1)],1),_vm._v(" "),_c('core-aside')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19ef0e87","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/containers/ContainerDefault.vue
// module id = 615
// module chunks = 1